import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Checkbox = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Checkbox' {...props}>
    <rect width='20' height='20' x='2' y='2' fill='none' stroke='#000' strokeWidth='2' />
  </StyledIcon>
);
